export const VERIFICATION_DOCUMENT_TYPES = ['governmentId', 'deedOrTax', 'voidCheck', 'supportingDocs'] as const

export type VerificationDocumentType = (typeof VERIFICATION_DOCUMENT_TYPES)[number]

export type VerificationDocument = {
  type: VerificationDocumentType
  assets: { id: string }[]
}
